import { SET_USER_DETAILS } from '../actions/actionTypes'

const initState = {
    userId : "",
    userName : "",
    userEmail : "",
    rawUserName : ""
}

const userDetailReducer = (state = initState, action) => {
    switch(action.type){
        case SET_USER_DETAILS : return {
            ...state,
            userId : action.userDetails.userId,
            userName : action.userDetails.userName,
            userEmail : action.userDetails.userEmail,
            rawUserName : action.userDetails.rawUserName
        }
        default : return state
    }
};

export default userDetailReducer;